import React, { createContext, useContext, useState } from "react";

const TeachingModeContext = createContext();

export const useTeachingMode = () => {
  const context = useContext(TeachingModeContext);
  if (!context) {
    throw new Error(
      "useTeachingMode must be used within a TeachingModeProvider",
    );
  }
  return context;
};

export const TeachingModeProvider = ({ children }) => {
  const [isTeachingMode, setIsTeachingMode] = useState(false);
  const [isWorkbookMode, setIsWorkbookMode] = useState(false);

  const resetToDefaultMode = () => {
    setIsTeachingMode(false);
    setIsWorkbookMode(false);
  };

  const value = {
    isTeachingMode,
    setIsTeachingMode,
    isWorkbookMode,
    setIsWorkbookMode,
    resetToDefaultMode,
  };

  return (
    <TeachingModeContext.Provider value={value}>
      {children}
    </TeachingModeContext.Provider>
  );
};
